var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data != null)?_c('div',[_c('edit-reservation',{attrs:{"edit":true,"data":_vm.data,"date":_vm.data.date,"type":'edit',"isSending":_vm.isSending},on:{"Cancel":_vm.cancel,"Save":_vm.edit}})],1):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }